const upperFirst = string =>
  `${string.charAt(0).toUpperCase()}${string.slice(1).toLowerCase()}`;

export default {
  SET_AVAILABLE_GROUPS(state, data) {
    state[`allAvailable${upperFirst(data.type)}Groups`] = data.value;
  },

  SET_MEMBERS_BY_TYPE(state, data) {
    state[data.type] = data.value;
  },

  SET_LOADING(state, value) {
    state.loading = value;
  },

  SET_SELECTED_GROUPS(state, value) {
    state.selectedGroups = value;
  },

  SET_SELECTED_AUTH_EVENTS(state, value) {
    state.selectedAuthEvents = value;
  }
};
